import { render } from "./ModalNovaOSAssistenciaTecnica.vue?vue&type=template&id=65f6368b&scoped=true"
import script from "./ModalNovaOSAssistenciaTecnica.vue?vue&type=script&lang=js"
export * from "./ModalNovaOSAssistenciaTecnica.vue?vue&type=script&lang=js"

import "./ModalNovaOSAssistenciaTecnica.vue?vue&type=style&index=0&id=65f6368b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f6368b"]])

export default __exports__